import { createStore } from 'vuex'
const store = createStore({
  state() {
    return {
      cachedViews: []
    }
  },
  getters: {
  },
  mutations: {
    // increment(state) {
    //   state.count++
    // }
  },
  actions: {
    // incrementAsync(context) {
    //   setTimeout(() => {
    //     context.commit('increment')
    //   }, 1000)
    // }
  },
  modules: {
  }
})
export default store